import { mainScripts } from './Libs/main';
import { searchFilter } from './Libs/searchfilter';

(function main() {
    searchFilter.init();
    mainScripts.init();
}());
